import { lift } from '../util/lift';
export function finalize(callback) {
    return function (source) { return lift(source, new FinallyOperator(callback)); };
}
var FinallyOperator = (function () {
    function FinallyOperator(callback) {
        this.callback = callback;
    }
    FinallyOperator.prototype.call = function (subscriber, source) {
        var subscription = source.subscribe(subscriber);
        subscription.add(this.callback);
        return subscription;
    };
    return FinallyOperator;
}());
//# sourceMappingURL=finalize.js.map